"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getFormatBatchItemStatus_1 = __importDefault(require("./getFormatBatchItemStatus"));
// 會把 setItems 的名子也放到 status
function getFormatBatchItemStatusWithSet(item) {
    const status = [];
    item.setItems.forEach(setItem => {
        let setStatus = setItem.name;
        const setItemStatus = getFormatBatchItemStatus_1.default(setItem);
        if (setItemStatus !== '') {
            setStatus += `(${setItemStatus})`;
        }
        status.push(setStatus);
    });
    const itemStatus = getFormatBatchItemStatus_1.default(item);
    if (itemStatus !== '') {
        status.concat(itemStatus);
    }
    return item.cancelled ? '已取消' : status.join('/');
}
exports.default = getFormatBatchItemStatusWithSet;
//# sourceMappingURL=getFormatBatchItemStatusWithSet.js.map